// Images
import bunTop from "../../assets/images/ingredients/bun_top.svg";
import bunBottom from "../../assets/images/ingredients/bun_bottom.svg";
import cheeseMelt from "../../assets/images/ingredients/cheese_melt.svg";
import lettuce from "../../assets/images/ingredients/lettuce.svg";
import pattyUncooked from "../../assets/images/ingredients/patty_uncooked.svg";
import pattyCooked from "../../assets/images/ingredients/patty_cooked.svg";
import pattyOvercooked from "../../assets/images/ingredients/patty_overcooked.svg";
import { burgerType } from "../../constants/ingredients";
import { useDrop, useDrag } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
// Styles
import "./styles.scss";

//Actions
import {
  updateBurgerTray,
  increaseMoves,
  increaseBunsPlaced,
  removefromGrillQueue,
} from "../../store/ingredient";

const BurgerComponent = (props) => {
  return (
    <div className="burger-element col-12" style={{ zIndex: props.zIndex }}>
      {props.image && <img src={props.image} alt="" srcset="" />}
    </div>
  );
};

const BurgerOnTray = (props) => {
  const dispatch = useDispatch();
  const burgerTray = useSelector((state) =>
    get(state, "ingredients.burgerTray")
  );

  const burgerMap = (ingredient) => {
    switch (ingredient) {
      case "pattyCooked":
        return pattyCooked;
      case "pattyUnCooked":
        return pattyUncooked;
      case "pattyOverCooked":
        return pattyOvercooked;
      case "buntop":
        return bunTop;
      case "cheese":
        return cheeseMelt;
      case "lettuce":
        return lettuce;
      case "bunbottom":
        return bunBottom;
    }
  };
  const [{ isOver }, drop] = useDrop({
    accept: "ingredient",
    drop: (item, monitor) => {
      if (
        ["pattyCooked", "pattyUnCooked", "pattyOverCooked"].includes(item?.name)
      ) {
        dispatch(
          removefromGrillQueue({
            index: item.index,
          })
        );
      }
      pushIngredientInBurger(item);
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const pushIngredientInBurger = (item) => {
    dispatch(increaseMoves());

    const ingredientArray = [...burgerTray[props.index].ingredients];
    if (item.name === "bun") {
      ingredientArray.push("bunbottom");
      ingredientArray.push("buntop");
      dispatch(increaseBunsPlaced());
    } else {
      const ingredientArrayLength = ingredientArray.length;
      if (
        ingredientArrayLength > 0 &&
        ingredientArray[0] === "bunbottom" &&
        ingredientArray[ingredientArrayLength - 1] === "buntop"
      ) {
        ingredientArray.splice(ingredientArrayLength - 1, 0, item.name);
      } else {
        ingredientArray.push(item.name);
      }
    }

    dispatch(
      updateBurgerTray({
        index: props.index,
        value: { ...burgerTray[props.index], ingredients: ingredientArray },
      })
    );
  };
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "burger",
    item: { index: props.index },

    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));
  return (
    <div className="burger-on-tray-style">
      {props.discountPoint ? (
        <div className="plus-point">
          <h4 className="title4">{props.discountPoint}</h4>
        </div>
      ) : (
        <></>
      )}
      <div
        className="burger-container-burgerontray"
        ref={drag}
        style={{ transform: "translate(0, 0)" }}
      >
        <div className="row" ref={drop}>
          {/* {makeBurger()} */}
          {props.ingredients.length <= 0 && (
            // <div className='row'>
            <>
              <div className="burger-element"></div>
              <div className="burger-element"></div>
              <div className="burger-element"></div>
            </>
            // </div>
          )}
          {props.ingredients
            .map((item, index) => {
              return (
                <BurgerComponent
                  i={index}
                  key={index}
                  zIndex={(index + 1) * 100}
                  image={burgerMap(item)}
                />
              );
            })
            .reverse()}
        </div>
      </div>
    </div>
  );
};

export default BurgerOnTray;
